'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var TRANSFORM = 'transform';
Entry.ExtGuide = /*#__PURE__*/function () {
  function ExtGuide(content, blockView, mode) {
    (0, _classCallCheck2["default"])(this, ExtGuide);
    this.blockView = blockView;
    this.block = blockView.block;
    this.model = content.model ? content.model : [];
    this.render();
  }
  return (0, _createClass2["default"])(ExtGuide, [{
    key: "render",
    value: function render() {
      if (!this.model) {
        return;
      }
      var board = this.blockView.getBoard();
      this.svgGroup = this.blockView.svgGroup.elem('g', {
        "class": 'extension guideGroup'
      });
      this.blockView.guideSvgGroup = this.svgGroup;
      $(this.svgGroup).bind('mousedown touchstart', function (e) {
        e.stopPropagation && e.stopPropagation();
        e.preventDefault && e.preventDefault();
      });
      var block = this.block;
      var code = block.getCode();

      //move blocks off the screen
      //in order to prevent magneting for some reasons
      this.model[0].x = -99999;
      this.model[0].y = -99999;
      var thread = code.createThread(this.model);
      !thread.view && thread.createView(board);
      var cloned = thread.getFirstBlock().view.clone();
      cloned.removeAttribute(TRANSFORM);
      this.svgGroup.appendChild(cloned);
      this.updatePos();
      this.block.getThread().view.setHasGuide(true);
      thread.destroy(false);
    }
  }, {
    key: "updatePos",
    value: function updatePos() {
      this.svgGroup.attr(TRANSFORM, this._getTransform());
    }
  }, {
    key: "_getTransform",
    value: function _getTransform() {
      return 'translate(0,%y)'.replace('%y', this.blockView.magnet.next.y);
    }
  }]);
}();